import axios from 'axios';
import React from 'react';
import { findDOMNode } from 'react-dom';
import app from '../../index';
import PriceForm from './PriceForm';
import PaymentForm from './PaymentForm';
import { TransitionItem, TransitionGroupMode } from '../components/transitions/Slide';
import InactiveDonation from './InactiveDonation';

export default class Donation extends React.Component {
  state = {
    showForm: 'price',
    form: {
      price: {
        price: 30
      }
    },
    formHeight: 'auto',
    wentBack: false
  };

  showPriceForm = (e, paymentFormData) => {
    e.preventDefault();

    this.setState({
      showForm: 'price',
      wentBack: true,
      form: {
        price: this.state.form.price,
        payment: paymentFormData
      }
    });
  };

  showPaymentForm = (e, priceFormData) => {
    e.preventDefault();

    this.setState({
      showForm: 'payment',
      wentBack: false,
      form: {
        price: priceFormData,
        payment: this.state.form.payment
      }
    });
  };

  pay = (e, paymentFormData) => {
    this.setState({
      form: {
        ...this.state.form,
        payment: paymentFormData
      }
    }, () => {
      const formData = {
        ...this.state.form.price,
        ...this.state.form.payment
      };

      formData.action = 'create-donation';
      formData.campaignId = this.props.initProps.campaignId;

      if (!formData.campaignId) {
        app.features.notification('.js-notification', {
          text: 'V náhľade na testovaciu kampaň nie je možné darovať',
          status: 'error'
        });

        return false;
      }

      if (formData.paymentMethod === 'button' && formData.buttonPaymentMethod) {
        formData.paymentMethod = formData.buttonPaymentMethod;
      }

      if (formData.price === 'custom' && formData.customPrice) {
        formData.price = formData.customPrice;
      }

      formData.isMonthlyDonation = formData.isMonthlyDonation === '1';
      formData.isAnonymousDonation = formData.isAnonymousDonation === '1';

      delete formData.buttonPaymentMethod;
      delete formData.customPrice;

      document.getElementById('loading').style.display = "block";
      axios.post('/p2p/darovat/', formData).then((response) => {
        window.location.href = response.data.donation.redirect_url;
      }).catch((error) => {
        document.getElementById('loading').style.display = "none";
        app.features.notification('.js-notification', {
          text: 'Nepodarilo sa darovať',
          status: 'error'
        });
      });
    });
  };

  updateHeight = () => {
    // eslint-disable-next-line react/no-find-dom-node
    const el = findDOMNode(this.state.showForm === 'price'
      ? this.formComponent1
      : this.formComponent2
    );

    if (!el) return;

    const newHeight = el.querySelector('.a-slide__height').clientHeight;

    if (this.state.formHeight !== newHeight) {
      this.setState({
        formHeight: newHeight
      });
    }
  };

  componentDidMount() {
    this.updateHeight();
    window.addEventListener('resize', this.updateHeight);
  }

  componentDidUpdate() {
    this.updateHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight);
  }

  render() {
    const { initProps = {} } = this.props;
    const { showForm, form, wentBack, formHeight: height } = this.state;

    if (initProps.disabled) {
      return <InactiveDonation {...initProps} />;
    }

    return (
      <div className="c-floating">
        <TransitionGroupMode height={height} mode="full" reversed={wentBack}>
          {showForm === 'price'
            ? <TransitionItem key={1} ref={c => { this.formComponent1 = c; }}>
                <PriceForm
                  {...initProps}
                  onSubmit={this.showPaymentForm}
                  form={form.price}
                  parentForceRerender={this.updateHeight}
                />
              </TransitionItem>
            : <TransitionItem key={2} ref={c => { this.formComponent2 = c; }}>
                <PaymentForm
                  onCancel={this.showPriceForm}
                  onSubmit={this.pay}
                  form={form.payment}
                  price={form.price.price === 'custom' ? form.price.customPrice : form.price.price}
                  isMonthlyDonation={+form.price.isMonthlyDonation}
                  parentForceRerender={this.updateHeight}
                />
              </TransitionItem>
          }
        </TransitionGroupMode>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/donation/index.js